import {Model} from './model';

/**
 * A country of legacy's `/apiv2/countries`, which is hard-coded to FI, EE, GB,
 * NO and SE (`CountriesController.cs` under `CoronaTool/Controllers/ApiV2/` in
 * the legacy checkout): an ISO 3166-1 alpha-2 code with an English name, as
 * legacy spells it (GB is "United Kingndom", which the mock fixture keeps).
 */
export class Country implements Model {
  code: string;
  name: string;

  static copy(oldObj: Country): Country {
    const newObj = new Country();
    newObj.code = oldObj.code;
    newObj.name = oldObj.name;
    return newObj;
  }

  public getPrimaryKey(): string {
    return this.code;
  }

  isNew(): boolean {
    return this.code == null;
  }

  clone(): Country {
    return Country.copy(this);
  }
}
